import React from "react";

import { makeFeedbackForm } from "../FeedbackForm";
import FeedbackModal from "./FeedbackModal";

type Props = {
  feedbackId: string;
  onCloseClick?: () => void;
  closeLink?: string;
  successButtonText?: string;
  onSubmitSuccess?: () => void;
};

export default function makeFeedbackModal(args: any) {
  const FeedbackForm = makeFeedbackForm(args);

  return function ({
    feedbackId,
    onCloseClick,
    closeLink,
    successButtonText,
    ...formProps
  }: Props) {
    return (
      <FeedbackModal
        feedbackId={feedbackId}
        onCloseClick={onCloseClick}
        closeLink={closeLink}
        successButtonText={successButtonText}
      >
        {{
          form: <FeedbackForm {...formProps} />
        }}
      </FeedbackModal>
    );
  };
}
